import { apiClient } from "lib/apiClient";
import { compactResearchParams } from "features/Research/constants";
import {
  IResearchSearchResponse,
  IResearchWorkItemsRequest,
} from "features/Research/types";

export const getResearchWorkItems = async (
  request: IResearchWorkItemsRequest
): Promise<IResearchSearchResponse> => {
  const response = await apiClient.get("/research/work-items", {
    params: compactResearchParams(request),
  });
  return response.data;
};
